// Sets window.__BUNDLE_STARTED__ as early as possible in the app bundle. If a
// white-screen record carries `bundleStarted: false`, the bundle never
// executed at all even though the file was reachable — the failure is below
// our code (loading / service worker / WebView2 host). Log-only signal for
// the inline watchdog in index.html.
//
// Production builds don't rely on this module's import position: vite.config
// prepends the same guarded statement as a rollup `banner`, which is the
// literal first statement of every emitted chunk. This module keeps the flag
// working in dev (no rollup banner there) and documents the contract.
try {
  if (typeof window !== "undefined" && !window.__BUNDLE_STARTED__) {
    window.__BUNDLE_STARTED__ = true;
    if (window.__crumb) window.__crumb("bundle-start");
  }
} catch (e) {
  // telemetry must never break startup
}
